<template>
  <a
      v-if="href"
      type="button"
      :class="[
        `_${type}`,
        `_${size}`,
        `_${colorTheme}`,
        {
          '_icon-right': isIconRightSide,
          '_icon-only': label.length === 0,
          '_long-icon': isLongIcon
        }
      ]"
      @click="onClick"
      :href="href"
      class="btn-custom"
  >
    <slot />
    <span
        v-if="label"
        v-html="label"
        class="button__text"
    ></span>
  </a>
  <button
      v-else
      type="button"
      :class="[
        `_${type}`,
        `_${size}`,
        `_${colorTheme}`,
        {
          '_icon-right': isIconRightSide,
          '_icon-only': label.length === 0,
          '_long-icon': isLongIcon
        }
      ]"
      :disabled="disabled"
      @click="onClick"
      :href="href"
      class="btn-custom"
  >
    <slot />
    <span
        v-if="label"
        v-html="label"
        class="button__text"
    ></span>
  </button>
</template>

<script>
export default {
  emits: ['onClick'],
  props: {
    label: {
      type: String,
      required: true,
      default: 'Перейти',
    },
    type: { // primary, secondary, outline, ghost
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: { // large, medium
      type: String,
      default: 'large'
    },
    colorTheme: { // light, dark
      type: String,
      default: 'light'
    },
    isIconRightSide: {
      type: Boolean,
      dafault: false
    },
    isLongIcon: {
      type: Boolean,
      dafault: false
    },
    href: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    }
  }
};
</script>
